export const settingsDispach = {
  searchText: 'Buscar...',
  export: false,
  checkbox: false,
  disabled: false,
  dialogHability: true,
  filter: false,
  sort: false,
  paginator: true,
  columns: [ 
    {
      title: "Nombre",
      name: "ruleName",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: any) => element.ruleName,
    },
    {
      title: "Tipo de regla",
      name: "typeOfRule",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: any) => element.typeOfRule,
    },
    {
      title: "Descripción",
      name: "description",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: any) => element.description,
    },
    {
      title: "Canal de venta",
      name: "sallerChanel",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: any) => element.sellerChanel,
    },
    {
      title: "Tipo de despacho",
      name: "dispatchType",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: any) => element.dispatchType,
    },
    {
      title: "Estado",
      name: "state",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: any) => element.state ? 'Activa' : 'Inactiva',
    }
  ],
  subTable: {},
};
